var _desc, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgInstitusjonsopphold(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "26px",
    height: "34px",
    viewBox: "0 0 26 34",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Color/26-places/building-2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "GDPR-Personopplysning-forside",
    transform: "translate(-326.000000, -5638.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Color/26-places/building-2",
    transform: "translate(322.000000, 5638.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-19",
    transform: "translate(4.250000, 0.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0,2.83333333 L2.71488453,0.208250001 C2.82500283,0.101716667 2.96604797,0.0323566668 3.11777691,0.00887400004 L3.23326054,0 L22.269668,0 C22.4254738,0 22.5756564,0.0480533335 22.6992232,0.135456001 L22.7865798,0.208250001 L25.5,2.83333333 L0,2.83333333 Z",
    id: "Path",
    fill: "#669DB4"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M25.5,2.83333333 L25.5,33.2916667 C25.5,33.6392223 25.2492676,33.928572 24.9189374,33.9885812 L24.7916667,34 L15.5833333,34 L15.5833333,27.625 C15.5833333,27.2774445 15.3326009,26.9880947 15.0022707,26.9280855 L14.875,26.9166667 L10.625,26.9166667 C10.2774445,26.9166667 9.98809466,27.1673993 9.92808551,27.4977293 L9.91666667,27.625 L9.91666667,34 L0.708333333,34 C0.360777779,34 0.0714279838,33.7492676 0.0114188386,33.4189374 L0,33.2916667 L0,2.83333333 L25.5,2.83333333 Z M7.08333335,19.8333334 L2.83333335,19.8333334 L2.83333335,24.0833334 L7.08333335,24.0833334 L7.08333335,19.8333334 Z M15.5833334,19.8333334 L9.91666671,19.8333334 L9.91666671,24.0833334 L15.5833334,24.0833334 L15.5833334,19.8333334 Z M22.6666667,19.8333334 L18.4166667,19.8333334 L18.4166667,24.0833334 L22.6666667,24.0833334 L22.6666667,19.8333334 Z M7.08333335,12.75 L2.83333335,12.75 L2.83333335,17 L7.08333335,17 L7.08333335,12.75 Z M15.5833334,12.75 L9.91666671,12.75 L9.91666671,17 L15.5833334,17 L15.5833334,12.75 Z M22.6666667,12.75 L18.4166667,12.75 L18.4166667,17 L22.6666667,17 L22.6666667,12.75 Z M7.08333335,5.66666668 L2.83333335,5.66666668 L2.83333335,9.91666668 L7.08333335,9.91666668 L7.08333335,5.66666668 Z M15.5833334,5.66666668 L9.91666671,5.66666668 L9.91666671,9.91666668 L15.5833334,9.91666668 L15.5833334,5.66666668 Z M22.6666667,5.66666668 L18.4166667,5.66666668 L18.4166667,9.91666668 L22.6666667,9.91666668 L22.6666667,5.66666668 Z",
    id: "Shape",
    fill: "#0C5472"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    fill: "#FFD399",
    x: 2.83333333,
    y: 5.66666667,
    width: 4.25,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy",
    fill: "#FFD399",
    x: 18.4166667,
    y: 5.66666667,
    width: 4.25,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-2",
    fill: "#FFD399",
    x: 18.4166667,
    y: 12.75,
    width: 4.25,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-5",
    fill: "#FFD399",
    x: 2.83333333,
    y: 12.75,
    width: 4.25,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-7",
    fill: "#FFD399",
    x: 9.91666667,
    y: 12.75,
    width: 5.66666667,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-8",
    fill: "#FFD399",
    x: 9.91666667,
    y: 19.8333333,
    width: 5.66666667,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-9",
    fill: "#FFD399",
    x: 9.91666667,
    y: 5.66666667,
    width: 5.66666667,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-4",
    fill: "#FFD399",
    x: 18.4166667,
    y: 19.8333333,
    width: 4.25,
    height: 4.25
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle-Copy-6",
    fill: "#FFD399",
    x: 2.83333333,
    y: 19.8333333,
    width: 4.25,
    height: 4.25
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstitusjonsopphold);
export default __webpack_public_path__ + "static/media/Institusjonsopphold.5b77c3b96c87602597a4ea61f292b810.svg";
export { ForwardRef as ReactComponent };